import {
  createListenerMiddleware,
  type Action,
  type CreateListenerMiddlewareOptions,
  type Dispatch,
  type ListenerMiddlewareInstance,
  type ThunkDispatch,
  type UnknownAction,
} from "@reduxjs/toolkit"

import { reportUnexpectedError } from "@/lib/report-unexpected-error"

export function createMtListenerMiddleware<
  StateType = unknown,
  DispatchType extends Dispatch<Action> = ThunkDispatch<
    StateType,
    unknown,
    UnknownAction
  >,
  ExtraArgument = unknown,
>(
  source: string,
  options?: Omit<CreateListenerMiddlewareOptions<ExtraArgument>, "onError">
): ListenerMiddlewareInstance<StateType, DispatchType, ExtraArgument> {
  return createListenerMiddleware<StateType, DispatchType, ExtraArgument>({
    ...options,
    onError: (error, errorInfo) => {
      reportUnexpectedError(error, source, {
        raisedBy: errorInfo.raisedBy,
      })
    },
  })
}
